// Packages
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Panel, Col, Button, ButtonGroup, Pagination } from 'react-bootstrap'

// Components
import Notification from './components/Notification'
import Message from './components/Message'

// Redux Actions
import { updateReadCount,
         getNotifications,
         readAllNotifications,
         deleteAllNotifications,
         readNotification,
         pinNotification,
         unpinNotification,
         deleteNotification } from './reducers/manageNotifications'

// CSS File
import './style.css'


class NotificationContainer extends Component {

  state = {
    selectedNotification: {},
    currentPage: 1,
    lastPaginationPage: 5
  }

  componentDidMount() {
    this.props.getNotifications(this.props.user.pk)
  }

  handleSelectNotification = (notification) => {
    const selectedNotification = {...notification, is_read: true}
    this.setState({ selectedNotification }, () => {
      if (!notification.is_read) {
        this.props.readNotification(notification, this.props.user.pk)
      }
    })
  }

  handlePinNotification = (notification) => {
    const selectedNotification = {...notification, is_pinned: true}
    this.setState({ selectedNotification }, () => {
      if (!notification.is_pinned) {
        this.props.pinNotification(notification, this.props.user.pk)
      }
    })
  }

  handleUnpinNotification = (notification) => {
    const selectedNotification = {...notification, is_pinned: false}
    this.setState({ selectedNotification }, () => {
      if (notification.is_pinned) {
        this.props.unpinNotification(notification, this.props.user.pk)
      }
    })
  }

  handlePaginationButtonChange = (currentPage, lastPage) => {
    if (currentPage === this.state.lastPaginationPage) {
      this.setState({ lastPaginationPage: this.state.lastPaginationPage + 5 })
    }
    if (currentPage + 5 === this.state.lastPaginationPage) {
      this.setState({ lastPaginationPage: this.state.lastPaginationPage - 5 })
    }
    if (currentPage === 'first') {
      this.setState({ lastPaginationPage: 5 })
    }
    if (currentPage === 'last') {
      let lastPaginationPage = lastPage
      if (lastPage % 5 > 0) {
        let remainder = lastPage % 5
        lastPaginationPage = lastPage - remainder + 5
      }
      this.setState({ lastPaginationPage })
    }
  }

  handlePaginationButtonClick = (page, currentPage) => {
    if (page < 1) {
      page = 1
    } else if (page > this.props.numberOfPages){
      page =  this.props.numberOfPages
    }

    this.handlePaginationButtonChange(currentPage, page)

    this.setState({ currentPage: page }, () => {
      this.props.getNotifications(this.props.user.pk, page)
    })
  }

  handleDeleteNotification = (url) => {
    if (this.props.notifications.data.length === 1 && this.state.currentPage > 1) {
      this.setState({ currentPage: this.state.currentPage - 1, selectedNotification: {} }, () => {
        this.props.deleteNotification(url, this.state.currentPage, this.props.user.pk)
      })
    } else {
      this.setState({ selectedNotification: {} }, () => {
        this.props.deleteNotification(url, this.state.currentPage, this.props.user.pk)
      })
    }
  }

  clearAllNotifications = () => {
    this.setState({ selectedNotification: {} }, () => {
      this.props.deleteAllNotifications(this.props.user.pk, this.props.notifications)
    })
  }

  render () {
    const { numberOfPages } = this.props
    // THE FOR LOOP ADDS PAGINATION BUTTONS FOR EACH NUMBER OF PAGES
    let buttons = []

    for (let i = 0; i < numberOfPages; i++) {
      buttons.push(
        <Pagination.Item
          active={this.state.currentPage === i + 1}
          key={i}
          onClick={() => this.handlePaginationButtonClick(i + 1)}
        >
          {i + 1}
        </Pagination.Item>
      )
    }

    // THIS ARRAY ADDS BUTTONS THAT TAKE THE USER TO THE FIRST PAGE AND BACK ONE PAGE
    // IN THE PAGINATED PROJECT RESULTS
    let firstButtons = [
      <Pagination.First
          key={ 'pagination-first' }
          onClick={ () => this.handlePaginationButtonClick(1, 'first') }
        />,
      <Pagination.Prev
          key={ 'pagination-back' }
          disabled={ this.state.currentPage === 1 ? true : false }
          onClick={ () => this.state.currentPage === 1 ? null: this.handlePaginationButtonClick(this.state.currentPage - 1, this.state.currentPage - 1) }
        />
    ]

    // THIS ARRAY ADDS BUTTONS THAT TAKE THE USER TO THE LAST PAGE AND FORWARD ONE PAGE
    // IN THE PAGINATED PROJECT RESULTS
    let lastButtons = [
      <Pagination.Next
        key={ 'pagination-next' }
        disabled={ this.state.currentPage === numberOfPages ? true : false }
        onClick={ () => this.state.currentPage === numberOfPages ? null: this.handlePaginationButtonClick(this.state.currentPage + 1, this.state.currentPage) }
      />,
      <Pagination.Last
        key={'pagination-last'}
        onClick={ () => this.handlePaginationButtonClick(numberOfPages, 'last') }
      />
    ]

    return (
      <div id="NotificationContainer">
        <div>
          {
            this.props.notifications.data.length ?
            <Pagination>
              { [...firstButtons, ...buttons.slice(this.state.lastPaginationPage - 5, this.state.lastPaginationPage), ...lastButtons] }
            </Pagination>
            :
            <Pagination>&nbsp;</Pagination>
          }
          <span id="main-buttons">
            <ButtonGroup>
              <Button
                className="read-all-btn"
                onClick={() => this.props.readAllNotifications(this.props.user.pk) }
              >
                Read All
              </Button>
              <Button
              className="clear-all-btn"
              onClick={this.clearAllNotifications}
              >
                Clear All
              </Button>
            </ButtonGroup>
          </span>
        </div>
        {
          this.props.isFetchingNotifications ?
          <center id="not-found">
            <img alt="loader" src={ require("../../static/images/spinner.gif") } />
          </center>
          :
          <Panel id="NotificationBox">
            {this.props.notifications.data.length ?
              <Panel.Body>
                <Col md={5} lg={5} id="NotificationList">
                  {this.props.notifications.data.map(notification => {
                    return (
                      <Notification
                        key={ notification.url }
                        selectNotification={ this.handleSelectNotification }
                        deleteNotification={ this.handleDeleteNotification }
                        notification={ notification }
                      />
                    )
                  })}
                </Col>
                <Col md={7} lg={7} id="NotificationBody">
                  {Object.keys(this.state.selectedNotification).length ?
                    <Message
                      notification={ this.state.selectedNotification }
                      pinNotification={ this.handlePinNotification }
                      unpinNotification={ this.handleUnpinNotification }
                    />
                    :
                    null
                  }
                </Col>
              </Panel.Body>
              :
              <center style={ { marginBottom: "10px" } }>
                <h4>You have no notifications</h4>
              </center>
            }
          </Panel>
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.manageLogin.user,
    notifications: state.manageNotifications.notifications,
    isFetchingNotifications: state.manageNotifications.isFetchingNotifications,
    numberOfPages: Math.ceil(state.manageNotifications.notifications.total_count / state.manageNotifications.notifications.resultsPerPage)
  }
}

export default connect(mapStateToProps, { updateReadCount, getNotifications, readAllNotifications, deleteAllNotifications, readNotification, pinNotification, unpinNotification, deleteNotification })(NotificationContainer);



// WEBPACK FOOTER //
// ./src/routes/notifications/NotificationContainer.js